const paths = {
  routeList: '/route/list',
  routeEdit: '/route/edit',
  routeUpdateLogistic: '/route/updateLogistic',
  routeMonitor: '/route/monitor',
  routeReport: '/route/report',
  routeStateReport: '/route/stateReport',
  routeAssignUnit: '/route/assignUnit',
  importRouteAssignments: '/route/importRouteAssignments',
  routeResolveWarnings: '/route/resolveWarnings',
  routeResolveWarningsMap: '/route/resolveWarningsMap',
  routeSecurity: '/route/security',
  routeSecurityHistory: '/route/securityHistory'
};

export default paths;
